export default {"src":"/_next/static/media/icon_continuous_performance.ba84fbb3.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};